import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
import classNames from 'classnames';
import Divider from '../../divider/divider';
var validTypes = {
  types: {
    options: ['subheader', 'title', 'divider'],
    defaultValue: 'title'
  }
};
var DropDownSection = function DropDownSection(props) {
  var getClassName = props.getClassName,
    key = props.key,
    automationId = props.automationId,
    dataHook = props.dataHook,
    type = props.type,
    title = props.title;
  var typeNormalized = type.toLowerCase();
  var sectionType = validTypes.types.options.includes(typeNormalized) ? typeNormalized : validTypes.types.defaultValue;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(getClassName('control-dropdown-section'), "".concat(sectionType, "-section")),
    key: key,
    "data-aid": automationId,
    "data-hook": dataHook
  }, sectionType === 'divider' ? /*#__PURE__*/React.createElement(Divider, {
    "long": true
  }) : title);
};
DropDownSection.displayName = displayNames.DROP_DOWN_SECTION;
DropDownSection.propTypes = {
  type: PropTypes.oneOf(validTypes.types.options),
  title: PropTypes.string
};
DropDownSection.defaultProps = {
  type: validTypes.types.defaultValue
};
export default compose(DropDownSection);